// extracted by css-extract-rspack-plugin
export default {"actionBtn":"PartnerFieldOptions_actionBtn__e-RFu","actionBtnWrapper":"PartnerFieldOptions_actionBtnWrapper__RkYg7"};